<template>
    <div>
		<EditAccount
			v-if="modalAccount"
			:accountData="{}"
			@closeModal="closeAccount"
			@newAccount="setAccount"
			:name="nameAccount"
		/>
        <b-modal
            ref="modalReceive"
            hide-footer
            size="md"
            no-overflow
            hide-no-focus="true"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">Executar recebimento</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal()"
                >
                    <xIcon/>
                </div>
            </div>
			<div class="modal-edicao mb-3 modal-edicao-label mt-6">
				<b-row class="filters-orientation">
					<b-col class="text-parcela">
						<label class="label-parcela">Data</label>
						<div class="d-flex">
							<datepicker
								class="w-100"
								placeholder=""
								id="receiveExecuteDate"
								input-class="bg-white"
								v-model="receiveExecuteDate"
								:format="formatter"
								:language="ptBR"
								:bootstrap-styling="true"
								data-cy="receiveExecuteDate"
							/>
						</div>
					</b-col>
					<b-col class="text-parcela">
						<label class="label-parcela">
							Conta
						</label>
						<SearchSelect
							name="account"
							:options="account.filter(account => account.permitePagamento && !account.inactive)"
							:visibleSuggestion="visibleSuggestion.account"
							:isMobile="isMobile"
							:newRecord="newAccount"
							:clearSelect="clearSelect"
							@changeSelect="changeSelect"
							@handleSuggestion="handleVisibleSuggestion"
							@invalidSearch="validateOptionSearch"
						/>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="text-parcela">
						<label class="label-parcela">Valor</label>
						<b-form-input
							name="receiveExecuteAmount"
							class="modal-edicao-input number-class"
							v-model="receiveExecuteAmount_string"
							inputmode="numeric"
							:disabled="true"
							@input="validateReceive"
							v-validate="`required|noZeroCurrency|notGreaterThan:${this.receiveExecuteAmount}`"
							:state="validateState('receiveExecuteAmount')"
							@focus="handleFocus('receiveExecuteAmount_string')"
							@blur="handleBlur('receiveExecuteAmount_string')"
						/>
					</b-col>
					<b-col v-if="showPartialReceive" class="text-parcela">
						<label class="label-conta mb-0">Parcial</label>
						<div style="display: flex !important; align-items: center; margin-top: -4px !important;">
							<div class="toggle-div mr-3">
								<ToggleSwitch
									name="partialReceive"
									class="toggle"
									:value="partialReceive"
									@toggle="_ => changeToggle('partialReceive')"
								/>
							</div>
						</div>
					</b-col>
				</b-row>
				<div v-if="partialReceive">
					<Installment
						:editing="editing"
						:date="receiveExecuteDate"
						@dataInstallments="setDataInstallments"
						:update="updateInstallments"
						@errorInstallments="validateInstallments"
						:disableAmount="true"
						:totalAmount="receiveExecuteAmount"
						partialReceive
						:enableValueWithOneInstallment="true"
					/>
				</div>
				<b-row class="mt-2">
					<b-col cols="12" class="d-block text-parcela">
						<label class="label-parcela">Observações</label>
						<b-form-input
							name="receiveExecuteComments"
							class="modal-edicao-input"
							v-model="receiveExecuteComments"
							autocomplete="off"
							placeholder=""
							v-validate="'maxLength:255'"
							:state="validateState('receiveExecuteComments')"
						/>
					</b-col>
				</b-row>
			</div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal()">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="clearModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="executeReceive"
                :disabled="invalidForm || saving || errorInstallments"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { possuiPermissao } from "../../helpers/permissions";
	import { numberFormatted, validateNumber, removeAccents } from "@/helpers/common";
	import { ToReceiveService } from "../../services/toReceive";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import Installment from "@/components/Installment.vue";
	import emitter from "@/eventBus.js";
	import { mapState } from "vuex";
	import EditAccount from "@/views/Account/EditAccount.vue";
	import SearchSelect from "@/components/SearchSelect.vue";

	export default {
		name: "FormReceive",
		components: {
			Datepicker,
			ToggleSwitch,
			Installment,
			EditAccount,
			SearchSelect
		},

		props: {
			transactionToReceive: {
				type: Array,
				required: true
			},
			showForm: {
				type: Boolean,
				require: true
			},
			isMobile: {
				type: Boolean,
				require: true
			}
		},
		data () {
			return {
				ptBR,
				toReceivePayloadObject: {},
				receiveExecuteAccount: null,
				receiveExecuteAmount: 0,
				receiveExecuteAmount_string: "0,00",
				receiveExecuteComments: "",
				receiveExecuteDate: new Date(),
				partialReceive: false,
				editing: false,
				updateInstallments: true,
				receiveExecute: [],
				errorInstallments: false,

				showPartialReceive: false,
				newToReceivedAmount: "0",

				saving: false,
				loading: false,

				toReceiveService: new ToReceiveService(),

				config: {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				},

				accountOptions: [],
				modalAccount: false,
				visibleSuggestion: {
					account: false
				},
				nameAccount: "",
				invalidSearch: {
					account: true
				},
				newAccount: {},
				invalidForm: true,
				invalidFormSearch: false,
				clearSelect: false
			};
		},


		watch: {
		},

		computed: mapState(["account", "accountClass"]),

		mounted () {
			this.showReceive(this.transactionToReceive);
			const paramsUser = localStorage.params ? (JSON.parse(localStorage.params)) : {};
		},

		methods: {
			changeToggle (key) {
				this[key] = !this[key];
				if (key === "partialReceive" && !this[key])
					this.errorInstallments = false;
			},

			setDataInstallments (data) {
				this.toReceivePayloadObject = {
					idsToReceive: this.receiveExecute,
					receivedDate: this.receiveExecuteDate,
					idAccount: this.receiveExecuteAccount,
					receivedAmount: data.receivedAmount,
					toReceiveAmount: this.receiveExecuteAmount,
					comments: this.receiveExecuteComments,
					sendLatePaymentMessage: data.sendMsg || false,
					partialReceive: this.partialReceive,
					toReceiveDataInstallments: data.toReceiveDataInstallments
				};
			},

			validateInstallments (valid) {
				this.errorInstallments = valid;
			},

			closeModal () {
				this.clearModal();
				this.receiveExecuteAmount = 0;
				this.receiveExecuteAmount_string = "0,00";
				this.$emit("closeForm", true);
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			async validateReceive () {
				this.receiveExecuteAmount_string = await validateNumber(this.receiveExecuteAmount_string);

				if (!this.receiveExecuteAmount_string || this.receiveExecuteAmount_string == 0)	{
					this.receiveExecuteAmount_string = numberFormatted(this.receiveExecuteAmount);
				}

				let amountReceived = this.receiveExecuteAmount_string.replace(/\./g, "");
				amountReceived = parseFloat(amountReceived.replace(",", "."));

				const amountToReceived = this.receiveExecuteAmount;
				this.newToReceivedAmount = numberFormatted(amountToReceived - amountReceived);
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			async executeReceive () {
				const baixaConfirmation = (await this.$swal({
					title: "Recebimento",
					text: "Tem certeza que deseja efetuar o recebimento?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (!baixaConfirmation)
					return;

				this.toReceivePayloadObject.idAccount = this.receiveExecuteAccount;
				this.toReceivePayloadObject.comments = this.receiveExecuteComments;
				this.toReceivePayloadObject.idsToReceive = this.receiveExecute;
				this.toReceivePayloadObject.receivedDate = this.receiveExecuteDate;
				if (!this.toReceivePayloadObject.receivedAmount)
					this.toReceivePayloadObject.receivedAmount = this.receiveExecuteAmount;

				const payload = this.toReceivePayloadObject;

				this.$snotify.async("Aguarde...", "Efetuando recebimento", async () => {
					try {
						this.saving = true;
						await this.toReceiveService.executeReceive({payload});

						emitter.emit("reloadAccount", { reload: true });

						if ( this.$route.path === "/")
							emitter.emit("reloadTransactions", { reload: true });

						this.$emit("saved", true);
						this.clearModal();
						return {
							title: "Sucesso!",
							body: "Recebimento efetuado com sucesso.",
							config: this.config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar efetuar recebimento.";
						throw {
							title: "Falha!",
							body: msgError,
							config: this.config
						};
					}
				});
			},

			clearModal () {
				this.receiveExecuteAccount = null;
				this.receiveExecuteComments = "";
				this.receiveExecuteDate = new Date();
				this.saving = false;
				this.loading = false;
				this.clearSelect = !this.clearSelect;
			},

			showReceive (transactionToReceive) {
				this.showPartialReceive = true;
				let totalAmount = 0;
				transactionToReceive.forEach(ttp => totalAmount = totalAmount + ttp.valor);

				this.receiveExecuteAmount = parseFloat(parseFloat(totalAmount).toFixed(2));
				this.receiveExecuteAmount_string = numberFormatted(totalAmount);

				this.receiveExecute = transactionToReceive.map(item => item);

				this.invalidForm = true;
				this.$refs.modalReceive.show();
			},

			showAccount () {
				this.modalAccount = true;
			},

			closeAccount (cancelled) {
				if (cancelled) {
					this.nameAccount = "";
				}

				this.modalAccount = false;
			},

			setAccount (newAccount) {
				this.newAccount = {
					id: newAccount[0].idAccount,
					description: newAccount[0].description
				};
				// Verificar rules of record
				const automaticPay = (this.accountClass.find(ac => ac.idAccountClass === newAccount[0].idAccountClass)).automaticPay || null;
				if (newAccount.inactive || !automaticPay) {
					this.newAccount.notPermited = true;
				}
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				if (value) {
					this.receiveExecuteAccount = value;
					this.nameAccount = text;
				} else {
					this.nameAccount = text;
					this.showAccount();
				}
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
			},

			handleVisibleSuggestion (handleSuggestion) {
				this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
			}

		}
	};
</script>